import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, TextField, Typography, Alert, Collapse } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import api from "../../../api/api";
import Loading from '../../../components/loading';
import { useParams, useNavigate } from 'react-router-dom';
import ErrorMessage from '../../../components/errorMessage';
import SuccessMessage from '../../../components/successMessage';

export default function GeneralEvolutionModal({ open, onClose, onEvolutionSave }) {

    const { patientId } = useParams();

    const [isLoading, setLoading] = useState(false);

    const navigate = useNavigate();
    
    const [evolutionDate, setEvolutionDate] = useState(dayjs());
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    
    useEffect(() => {
    }, [open]);

    const saveGeneralEvolution = (event) => {
        event.preventDefault();
        setError('');

        if (!description.trim() || !DatePicker) {
            setError("Todos os campos são obrigatórios!");
            return;
        }

        const evolution = {
            pacienteId: patientId,
            data: evolutionDate,
            evolucao: description,
        };

        setLoading(true);
        api.post("/paciente/evolucao", evolution, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            setLoading(false);
            onEvolutionSave(returnFromApi);
            setSuccessMessage(true);
            cleanFields();
        }).catch((returnFromApi) => {
                setLoading(false);
                console.error("ops! ocorreu um erro" + returnFromApi);
                setErrorMessage(returnFromApi.response.data);
                if (returnFromApi.status === 401) {
                    navigate("/expired-session");
                }        
        });
    };

    function cleanFields() {
        setDescription('');
        setEvolutionDate(dayjs());
    }

    return (
        <>
         <Loading isToHidden={isLoading === false} />
            {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
            {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}
        
        
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">

            <Loading isToHidden={isLoading === false} />

            <DialogTitle>
                <Typography variant="outlined" sx={{ fontWeight: 'bold' }}>
                    Adicionar Evolução Geral
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Collapse in={!!error} sx={{ mt: 1, mb: 1 }}>
                    <Alert severity="error" onClose={() => setError('')}>
                        {error}
                    </Alert>
                </Collapse>

                <Grid>
                    <Grid size={1}>
                        <DatePicker label="Data da Evolução" value={evolutionDate} onChange={(newValue) => setEvolutionDate(newValue)} slotProps={{ textField: { fullWidth: true } }} />
                    </Grid>
                    <Grid size={8}>
                        <TextField fullWidth label="Descrição" multiline rows={4} value={description} onChange={(e) => setDescription(e.target.value)} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={saveGeneralEvolution} variant="contained">Salvar</Button>
            </DialogActions>
        </Dialog>
      </>
    );
}